import { Button } from '@bpba/ui-components';
import styled from 'styled-components';
import { TypographyProps, typography, SpaceProps } from 'styled-system';

type TextWrap = 'wrap' | 'nowrap' | 'balance' | 'stable';

type Props = {
  blocked?: boolean;
  textWrap?: TextWrap;
} & TypographyProps &
  SpaceProps;

export const StyledButton = styled(Button)<Props>(
  {
    borderRadius: '3px 8px',
    fontWeight: 500,
    opacity: 1,
    ':hover': {
      opacity: 0.5,
    },
  },
  typography,
  (props) => ({
    cursor: props.blocked ? 'not-allowed' : 'pointer',
    textWrap: props.textWrap,
  })
);